import React, { forwardRef } from 'react';

type InputProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, InputProps>(
  (props, ref) => (
    <textarea
      ref={ref}
      {...props}
      className="p-4 outline-none text-2xl h-[200px] bg-input resize-none text-2xl font-bold tracking-wider italic"
    />
  ),
);
